import {Injectable} from 'ng-metadata/core';
import {PushtoService} from "../pushto.service";

@Injectable()
export class RefWorksService {
    private popupWin: Window;

    constructor(private pushtoService: PushtoService){
    }

    public refworksAction(item, selectedIds){
        let failedAction = angular.bind(this, this.failedPushtoAction);
        let successAction = angular.bind(this, this.successfullPushtoAction);
        let pushtoPromise = this.pushtoService.getServiceUrl([item], selectedIds, 'refworks');
        pushtoPromise.then((response)=>successAction(response), (response)=>failedAction(response));
    }

    private successfullPushtoAction(response) {
        let serviceUrl = response.data.serviceUrl;
        let data = response.data.data;

        let form = this.createRefworkdForm(serviceUrl, data);
        document.body.appendChild(form);
        this.popupWin = window.open('', 'refworks-window');
        form.submit();
        document.body.removeChild(form);

        console.log("Refworks successfully sent");
    }

    private failedPushtoAction(event, response) {
        console.log("Refworks call failed");
    }

    private createRefworkdForm(serviceUrl: string, data: string): HTMLFormElement{
       
        let form = document.createElement('form');
        form.setAttribute('accept-charst', 'UTF-8');
        form.setAttribute('name', 'ExportForm');
        form.setAttribute('method', 'POST');
        form.setAttribute('style', 'display: none');
        form.setAttribute('target', 'refworks-window');
        form.setAttribute('action', serviceUrl);
        
        let div = document.createElement('div');
        div.innerHTML = data;
        form.appendChild(div.firstChild);

        return form;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/refworksAction/refworks.service.ts